import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './Overview.styles';
import { getOverviewData } from './Overview.helpers';
import { OverviewData } from './Overview.types';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { useAdDetails } from '@/views/Ads/useAdDetails';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

export const Overview: React.FC = () => {
  const { t } = useTranslation();
  const { adDetails } = useAdDetails();
  const overviewData = adDetails
    ? getOverviewData(t, adDetails)
    : Array.from({ length: 3 }, (_, index) => ({ id: index } as OverviewData));

  return (
    <S.Box {...(!adDetails && { 'data-testid': 'overview-skeleton-loader' })}>
      {overviewData.map(({ id, name, value }) =>
        name ? (
          <S.Item key={id}>
            <S.Name>{name}</S.Name>
            <Typography.Body>{value}</Typography.Body>
          </S.Item>
        ) : (
          <S.Item key={id}>
            <SkeletonLoader height="18px" />
            <SkeletonLoader height="18px" />
          </S.Item>
        )
      )}
    </S.Box>
  );
};
